var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.location)?_c('div',[_c('Properties',{attrs:{"subModel":_vm.subModel,"model":_vm.model,"location":_vm.location,"locationProperties":_vm.locationProperties != null ? _vm.locationProperties.filter(_vm.selectViewLocation) : null,"propertyIcons":_vm.propertyIcons,"showIconMenu":true}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }